import createCrudService from '@core/api/create-crud-service';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

import type { TField } from '@shared/types/field';
import type { TBaseQuery } from '@shared/types/base-query';
import type { TCustomField } from '@shared/types/custom-field';

export type TCustomFieldsQuery = {
  entity?: TCustomField['entity'];
  organization?: number;
  type?: TField['type'];
} & TBaseQuery;

type CreateCustomFieldPayload = {
  name: string;
  label?: string;
  entity: TCustomField['entity'];
  type: TField['type'];
  options?: string[];
};

const customFieldApi = createCrudService<
  TCustomField,
  TCustomFieldsQuery,
  CreateCustomFieldPayload
>({
  queryKey: [QUERY_KEYS.getCustomFields],
  url: 'custom-fields',
});

export default customFieldApi;
